import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API_BASE_URL from '../config/api';
const T = { bg: '#FAF9F6', dark: '#1A2238', ink: '#0F1420', gold: '#C39B62', muted: '#9a9a9a', border: '#E6E8EA' };

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/vrv-auth-forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ emailID: email }),
      });
      const data = await res.json();
      if (res.ok) { setSent(true); setMessage(data.message || 'Password reset link sent.'); setMessageType('success'); }
      else { setMessage(data.message || data.error || 'Failed to send reset link.'); setMessageType('error'); }
    } catch { setMessage('Error connecting to server'); setMessageType('error'); }
    setLoading(false);
  };

  const inputCls = "w-full px-5 py-4 rounded-lg text-base focus:outline-none transition-colors";
  const inputStyle = { backgroundColor: T.bg, border: `1px solid ${T.border}`, color: T.ink };

  return (
    <div className="h-screen flex overflow-hidden" style={{ backgroundColor: T.bg }}>
      {/* Left Panel */}
      <div className="hidden lg:flex lg:w-1/2 flex-col justify-between p-16" style={{ backgroundColor: T.dark, borderRight: `1px solid ${T.ink}` }}>
        <img src="/images/VRV.png" alt="VRV" className="h-24 w-24 object-contain" style={{ filter: 'drop-shadow(0 0 30px rgba(195,155,98,0.6)) drop-shadow(0 0 60px rgba(195,155,98,0.25))' }} />
        <div>
          <p className="text-xs font-bold tracking-[0.35em] uppercase mb-6" style={{ color: T.gold }}>Account Recovery</p>
          <h2 className="text-6xl md:text-8xl font-black leading-none mb-8" style={{ color: '#FAF9F6' }}>
            RESET<br /><span style={{ color: T.gold }}>YOUR</span><br />PASSWORD
          </h2>
          <div className="w-16 h-0.5 mb-8" style={{ backgroundColor: T.gold }}></div>
          <p className="text-sm leading-relaxed max-w-sm" style={{ color: 'rgba(250,249,246,0.5)' }}>
            We'll send a secure link to your registered email to help you regain access.
          </p>
        </div>
        <p className="text-xs italic" style={{ color: 'rgba(195,155,98,0.35)' }}>"In service of Lord Vishnu and the Vaikhanasa tradition"</p>
      </div>

      {/* Right Panel */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-16 py-12" style={{ backgroundColor: T.bg }}>
        <div className="w-full">
          {!sent ? (
            <>
              <p className="text-xs font-bold tracking-[0.25em] uppercase mb-3" style={{ color: T.gold }}>Account Recovery</p>
              <h1 className="text-5xl font-black mb-2" style={{ color: T.ink }}>Forgot Password</h1>
              <p className="text-base mb-12" style={{ color: T.muted }}>Enter your email to receive a reset link</p>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-xs font-bold tracking-widest uppercase mb-2" style={{ color: T.ink }}>Email Address</label>
                  <input type="email" placeholder="you@example.com" className={inputCls} style={inputStyle}
                    onFocus={e => e.target.style.borderColor = T.gold} onBlur={e => e.target.style.borderColor = T.border}
                    value={email} onChange={e => setEmail(e.target.value)} required />
                </div>
                <button type="submit" disabled={loading}
                  className="w-full font-black py-5 rounded-lg text-sm tracking-widest uppercase transition-opacity disabled:opacity-50"
                  style={{ backgroundColor: T.dark, color: '#FAF9F6' }}>
                  {loading ? 'Sending...' : 'Send Reset Link →'}
                </button>
              </form>
              {message && (
                <div className="mt-4 text-sm px-4 py-3 rounded-lg" style={{ color: messageType === 'success' ? '#15803d' : '#b91c1c', backgroundColor: messageType === 'success' ? '#f0fdf4' : '#fef2f2', border: `1px solid ${messageType === 'success' ? '#bbf7d0' : '#fecaca'}` }}>
                  {message}
                </div>
              )}
            </>
          ) : (
            <>
              <p className="text-xs font-bold tracking-[0.25em] uppercase mb-3" style={{ color: T.gold }}>Email Sent</p>
              <h1 className="text-5xl font-black mb-2" style={{ color: T.ink }}>Check Your Email</h1>
              <p className="text-base mb-12" style={{ color: T.muted }}>A reset link has been sent to <span className="font-bold" style={{ color: T.ink }}>{email}</span></p>
              <div className="px-6 py-5 rounded-xl mb-6" style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                <p className="text-sm" style={{ color: '#15803d' }}>Please check your inbox and spam folder. Click the link in the email to reset your password.</p>
              </div>
              <button onClick={() => { setSent(false); setMessage(''); }}
                className="font-black px-8 py-3.5 text-xs tracking-widest uppercase rounded-lg transition-all"
                style={{ border: `2px solid ${T.dark}`, color: T.dark, backgroundColor: 'transparent' }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = T.dark; e.currentTarget.style.color = '#FAF9F6'; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = T.dark; }}>
                Try Again
              </button>
            </>
          )}
          <p className="text-base mt-10 text-center" style={{ color: T.muted }}>
            Remember your password?{' '}
            <Link to="/login" className="font-bold" style={{ color: T.dark }}>Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
